import { createSlice, createSelector } from "@reduxjs/toolkit";

const profileSliceSelector = createSlice({
  name: "profileSlice",
  initialState: {
    isLoading: false,
    loaderMessage: "",
    profileData:{}
  },
  reducers: {
    startGettingProfile(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setProfile(state, action) {
      state.profileData = action.payload;
    },
    startEditProfileData(state, action) {
      state.isLoadingNewAdd = true;
      state.loaderMessage = "Adding user please wait...";
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = "";
    },
    completedEditProfileData(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = "";
    },
  },
});

export const {
  startGettingProfile,
  setProfile,
  startEditProfileData,
  completedFetch,
  completedEditProfileData
} = profileSliceSelector.actions;
export default profileSliceSelector.reducer;

//Selector
const mainReducer = (state) => state.ProfileData;

export const profileDataSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.profileData
);
